import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b66e3df")

_pushScopeId("data-v-5b66e3df")
const _hoisted_1 = { class: "holder" }
const _hoisted_2 = { class: "webinar-section" }
const _hoisted_3 = {
  key: 0,
  class: "nav"
}
const _hoisted_4 = {
  key: 0,
  href: "#parmonic-moments"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, [
    /*#__PURE__*/_createVNode("path", {
      class: "icon-color",
      d: "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    })
  ])
], -1)
const _hoisted_6 = {
  key: 1,
  href: "#parmonic-resources"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, [
    /*#__PURE__*/_createVNode("path", {
      class: "icon-color",
      d: "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    })
  ])
], -1)
const _hoisted_8 = {
  key: 2,
  href: "#parmonic-speakers"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, [
    /*#__PURE__*/_createVNode("path", {
      class: "icon-color",
      d: "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    })
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  class: "timeline-section"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TrailerTimeline = _resolveComponent("TrailerTimeline")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", {
        class: "webinar-title",
        innerHTML: _ctx.translateWebinar(_ctx.widgetData).title
      }, null, 8, ["innerHTML"]),
      _createVNode("p", {
        class: "webinar-description",
        innerHTML: _ctx.translateWebinar(_ctx.widgetData).description
      }, null, 8, ["innerHTML"]),
      (_ctx.widgetData.show_info_tab_anchors)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.showMoments)
              ? (_openBlock(), _createBlock("a", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.translateLabels("Key Moments")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showResources)
              ? (_openBlock(), _createBlock("a", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.translateLabels("Resources")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showSpeakers)
              ? (_openBlock(), _createBlock("a", _hoisted_8, [
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.translateLabels("Speakers")), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.widgetData.trailer_data)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode(_component_TrailerTimeline, {
            moments: _ctx.moments,
            resources: _ctx.widgetData.related_resources,
            webinar_duration: _ctx.widgetData.duration,
            video_urls: _ctx.widgetData.trailer_data.video_urls,
            subtitles: _ctx.widgetData.trailer_data.subtitles,
            duration: _ctx.widgetData.trailer_data.duration,
            title: _ctx.translateWebinar(_ctx.widgetData).title,
            use_demo_overlay: _ctx.widgetData.use_demo_overlay,
            overlay_logo: _ctx.widgetData.overlay_logo,
            usetheaterMode: _ctx.usetheaterMode
          }, null, 8, ["moments", "resources", "webinar_duration", "video_urls", "subtitles", "duration", "title", "use_demo_overlay", "overlay_logo", "usetheaterMode"])
        ]))
      : _createCommentVNode("", true)
  ]))
})